import { render, staticRenderFns } from "./CallParticipants.vue?vue&type=template&id=521b40d9&"
import script from "./CallParticipants.vue?vue&type=script&lang=js&"
export * from "./CallParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports